//
//
//
//
//
//
//
//
//
//
//
//

	export default{
		props:{
			messageData:{
				type:Object,
				default:()=>{
					return {
						show:false,
						text:'',
					}
				}
			},
			isLogout:false
		},
		name:'messagebox',
		data(){
			return{
				
			}
		},
		
		methods:{
			close(){				
				this.set_messageData({
					show:false
				})
				if(this.messageData.path == 'extension?info=red'){
					this.set_redShow(true)
				}
			},
			//确定
			determine(){
				sessionStorage.setItem('renew',JSON.stringify([]))
				this.close()
			},
		}
	}
